import React from 'react';
import * as R from 'ramda';
import Select from 'react-select';
import {FormGroup, Label} from 'reactstrap';
import classNames from 'classnames';
import {useTranslation} from 'react-i18next';

import {wrap, present} from '@/util';

import {useFieldState, ErrorTooltip} from '@/Form/index';
import '@/Form/react-select.css';

// TODO:
// - loadingMessage i18n
// - noOptionsMessage i18n

// HINT:
// - can use `menuIsOpen` prop to force dropdown opened

const parseSelected = multiple =>
  R.compose(
    multiple ? R.identity : R.head,
    R.map(R.prop('value')),
    wrap
  );

const autoContainerId = id => `_auto_id_${id}`;

const ReactSelect = ({
  id,
  name,
  options,
  label,
  multiple = false,
  disabled,
  isClearable = true,
  className = '',
  ...rest
}) => {
  const {
    id: target,
    value: values,
    onChange,
    errors,
    ...fieldState
  } = useFieldState({
    id,
    name,
  });

  const containerId = autoContainerId(target);
  const {t: tr} = useTranslation();

  // TODO: support single select default value
  const defaultValues = R.ifElse(present, R.always(values), R.always([]))(
    values
  );

  const handleSelectChange = selected => {
    onChange({target: {name, value: parseSelected(multiple)(selected)}});
  };

  const invalidClass = fieldState.invalid ? 'is-invalid' : null;

  return (
    <FormGroup>
      <Label htmlFor={target}>{label}</Label>
      <Select
        onChange={handleSelectChange}
        options={options}
        {...fieldState}
        {...rest}
        id={containerId}
        inputId={target}
        value={options.filter(({value}) => R.includes(value, defaultValues))}
        isMulti={multiple}
        isDisabled={disabled}
        isClearable={isClearable}
        className={classNames(className, invalidClass)}
        classNamePrefix='react-select'
        placeholder={tr('common:react_select_placeholder')}
      />
      <ErrorTooltip errors={errors} target={containerId} />
    </FormGroup>
  );
};

export default ReactSelect;
